import styled from 'styled-components'

import { colors } from '../../../constants'

const NavBarHeight = '60px'

export const Bar = styled.div`
    background: ${colors.bluedarkest};
    float: left;
    margin: 0;
    padding: 44px 0 0;
    position: relative;
    text-align: center;
    width: 60px;
    z-index: 5;

    ${({ fullscreen }) => `height: ${fullscreen ? '100%' : `calc(100% - ${NavBarHeight})`};`}
`
